import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { commonEnumValidator } from '@zaoblako/shared/modules/serde/validators/common-enum.validator';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { StorageBackendValidatorsEnum } from '@zaoblako/shared/modules/storage/enums/storage-backend-validators.enum';
import { KnowledgeBaseCategoryEnum } from '@zaoblako/shared/modules/ai/enums/knowledge-base-category.enum';
import { KnowledgeBaseCategoryEnumI18n } from '@zaoblako/shared/modules/ai/i18n/knowledge-base-category-enum.i18n';
import { entityLikeSchemaUuid } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import type { SerdeContextInterface } from '@zaoblako/shared/modules/serde/interfaces/serde-context.interface';
import type { SerdeContextDataInterface } from '@zaoblako/shared/modules/serde/interfaces/serde-context-data.interface';
import type { FileFindInterface } from '@zaoblako/shared/modules/storage/dtos/file/file-find.dto';

import * as yup from 'yup';

/** Knowledge base create/update request body */
export interface KnowledgeBaseFormInterface {
  /** Knowledge base title */
  title: string;
  /** Knowledge base content */
  content?: string;
  /** Knowledge base embedding with 1536 length */
  embedding1536?: number[];
  /** Knowledge base embedding with 1024 length */
  embedding1024?: number[];
  /** Knowledge base embedding with 256 length */
  embedding256?: number[];
  /** Knowledge base type */
  category: KnowledgeBaseCategoryEnum;
  /** File attached to knowledge base */
  file?: FileFindInterface;
  /** Knowledge base content hash */
  contentHash?: string;
}

/** Knowledge base create/update request body - DTO schema */
export const KnowledgeBaseFormDto = SerdeDtoClass.create<KnowledgeBaseFormInterface>(CatalogDtosKeysEnum.KNOWLEDGE_BASE_FORM_DTO, {
  title: {
    sortable: true,
    label: 'Заголовок',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
  content: {
    optional: (context: SerdeContextInterface<SerdeContextDataInterface, KnowledgeBaseFormInterface>) => !!context?.value?.file?.id,
    label: 'Знание',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
  embedding1536: {
    optional: true,
    label: 'Эмбеддинг',
    hint: 'Длина 1536',
    serializer: yup.array(yup.number()),
  },
  embedding1024: {
    optional: true,
    label: 'Эмбеддинг',
    hint: 'Длина 1024',
    serializer: yup.array(yup.number()),
  },
  embedding256: {
    optional: true,
    label: 'Эмбеддинг',
    hint: 'Длина 256',
    serializer: yup.array(yup.number()),
  },
  category: {
    label: 'Категория',
    serializer: commonEnumValidator(KnowledgeBaseCategoryEnum, KnowledgeBaseCategoryEnumI18n),
  },
  file: {
    optional: true,
    label: 'Файл',
    serializer: entityLikeSchemaUuid,
    checkers: [StorageBackendValidatorsEnum.FILE_ASSERT_EXISTS_BY_DTO],
  },
  contentHash: {
    optional: true,
    label: 'Хеш контента',
    serializer: yup.string(),
  },
});
